/**
 * AuthPort — porta de autenticação.
 *
 * O app do monorepo importava `keycloakAuthPort` de `@nasajon/erprompt-entity-client`
 * e o boot inteiro (Keycloak → Router → Intl → Profile → ErrorBoundary) vinha de
 * `renderApp`. Aqui a dependência é invertida: a aplicação declara a *porta* que
 * precisa e o composition root injeta uma implementação. Nada no restante do
 * código conhece Keycloak.
 */

export interface AuthPort {
  /** Devolve um access token válido, renovando quando necessário. */
  getToken(): Promise<string>;
  /** Identificação do usuário para o chip da topbar. Nulo = anônimo/demo. */
  getIdentity(): Promise<{ nome: string; detalhe: string } | null>;
  /** Capabilities/roles do usuário (client `pan-api` + roles de realm relevantes) — pro chip exibir. */
  getRoles(): Promise<string[]>;
  /** Encerra a sessão. Não aplicável em demo (no-op). */
  logout(): void;
}

/** Porta usada no modo demo e em desenvolvimento sem provedor configurado. */
export function createStaticAuthPort(token: string, identity?: { nome: string; detalhe: string }): AuthPort {
  return {
    getToken: async () => token,
    getIdentity: async () => identity ?? null,
    getRoles: async () => [],
    logout: () => {},
  };
}

let current: AuthPort = createStaticAuthPort('');

export function setAuthPort(port: AuthPort): void {
  current = port;
}

export function getAuthPort(): AuthPort {
  return current;
}
